
export const mixin = {
  data: function () {
    return {
      showCopyUserDelete:false,
      ifSelCopy:true,
      copyUserModel: {
        // 抄送模型
        isShow: false,
        selectList: [],
        callBack: this.selectCopyUserCallback,
        radioSelectFlags: false
      }
    }
  },
  props: {

  },
  computed:{

  },
  created () {

  },
  mounted () {

  },
  methods: {
    cancel(){
      this.$emit('handleCancel')
    },
    ok(){
      if(this.copyUserModel.selectList.length == 0){
        this.util.warn("请至少设置一个抄送人！");
        return;
      }
      var copyUsersArr = new Array()
      for (var i = 0; i < this.copyUserModel.selectList.length; i++) {
        var procUser = this.copyUserModel.selectList[i]
        var user = new Object()
        user.id = procUser['id']
        user.userName = procUser['userName']
        user.mobile = procUser['mobile']
        user.wxId = procUser['wxId']
        copyUsersArr.push(user)
      }
      // console.log('------this.$parent------',this.$parent,this);
      // 第一层是el-dialog
      let params = this.$parent.$parent.getData();
      if(params == null){
        this.util.warn("主表数据为空！");
        return;
      }
      // console.info(this.copyUserModel.users);
      params['ifSaveWorkflow'] = true;
      params['copyUsersStr'] = JSON.stringify(copyUsersArr)
      console.log('--------params--------',params);
      let _this = this;
      // 表示结束后的抄送
      params['operateType'] = 18;
      this.util.mask('正在抄送...');
      _this.util.restPost('/api_v1/form/business', params, function (res) {
        if(res.status== 200){
          _this.util.success('操作成功！');
          _this.cancel()
        }else{
          _this.util.error('操作失败!' + res['errorMsg']);
        }
        _this.util.unmask();
      });
    },
    addCopyUser () {
      // 添加处理人
      console.info(this.$refs.selectCopyUser)
      this.copyUserModel.isShow = true
      // this.$refs.selectCopyUser.sync(this.copyUserModel.selectList);
    },
    removeCopyUser (user) {
      this.copyUserModel.selectList = this.copyUserModel.selectList.filter(
        item => {
          return item != user
        }
      )
    },
    delCopyUser () {
      this.showCopyUserDelete = !this.showCopyUserDelete
    },
    selectCopyUserCallback () {
      // console.info("====selectCopyUserCallback====");
      this.copyUserModel.isShow = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/wf/copy-form/index.js